import { AuthProvider } from "react-admin"
import axios from "axios"
import { default as routes} from "api/routes"
import * as tokens from "api/auth/tokens"
import { AxiosRequestConfig } from "axios"
import { fetchWithToken } from "api/data"
import { storage } from "utils"

export const authProvider: AuthProvider = {
  login: ({ username, password }) => {
    return axios
      .post(routes.signin(), { username, password })
      .then((response) => {
        const accessToken = response.headers['authorization'].split(' ')[1]
        const refreshToken = response.headers['x-refresh-token']

        tokens.updateAccessToken(accessToken)
        return tokens.saveRefreshToken(refreshToken)
      })
      .then(() => {
        return Promise.resolve()
      })
      .catch((error) => Promise.reject(error))
  },

  logout: () => {
    tokens.deleteAccessToken()
    tokens.deleteRefreshToken()
    storage.remove('currentUser')
    return Promise.resolve()
  },

  checkAuth: () => {
    return tokens.lastAccessToken() !== ""
      ? Promise.resolve()
      : Promise.reject()
  },

  getIdentity: () => {
    const config: AxiosRequestConfig = {
        url: routes.userInfo(),
        method: 'get',
    }
    return fetchWithToken(config)
      .then((response) => {
          const { id, name } = response.data
          storage.update('currentUser', JSON.stringify(response.data))
          return Promise.resolve({ id: id, fullName: name, avatar: "" })
      })
      .catch((error) => Promise.reject(error))
},

  checkError: () => Promise.resolve(),

  getPermissions: () => Promise.resolve(),

}

export default authProvider
